module.exports = __webpack_public_path__ + "img/QRCode_joinUs.850f7143.png";